module.exports = __webpack_public_path__ + "img/effective-protection-sector-azulBranco.e6b757f4.svg";